export default "__VITE_ASSET__Cdp5Upgb__"